import React from "react";
import "./WidgetRotator.scss";

/**
 * WidgetRotator (super minimal)
 *
 * Props:
 * - children: ReactNode
 * - rotated: boolean         // controlled from parent
 * - durationMs?: number      // transition speed (default 220)
 * - className?: string
 * - style?: React.CSSProperties
 */
export default function WidgetRotator({
  children,
  rotated,
  durationMs = 220,
  className = "",
  style,
}) {
  return (
    <div
      className={[
        "widgetRotator",
        rotated ? "rotated" : "regular",
        className,
      ].join(" ")}
      style={{ "--wr-duration": `${durationMs}ms`, ...style }}
    >
      {children}
    </div>
  );
}
